module.exports = __webpack_public_path__ + "fonts/Inter-SemiBoldItalic.81678d1.woff";